import * as storageConstants from "../../shared/utils/constants/storage";
import * as actionTypes from "../actionTypes";
import {store} from "../store";
import axios from "axios";
import {encodeData} from "../../shared/utils/axiosUtils";
import ServiceRequestsService from "../../api/serviceRequestsService";

let aperteCancelToken = axios.CancelToken.source();
let archiviateCancelToken = axios.CancelToken.source();
let suggestionCancelToken = axios.CancelToken.source();

export const assistenzaSetSelectedTab = (value) => {
    sessionStorage.setItem(storageConstants.ASSISTENZA_TAB, value);
    return {
        type: actionTypes.ASSISTENZA_SET_SELECTED_TAB,
        selectedTab: value
    }
}

export const fetchDataAperte = (page, rowsPerPage, filterBy, searchText) => {
    return dispatch => {
        let integrationId = store.getState().authReducer.selectedCompany.integrationId;
        let state = store.getState().richiestaAssistenzaReducer.aperte;

        if (state.loading) {
            aperteCancelToken.cancel();
            aperteCancelToken = axios.CancelToken.source();
        }

        dispatch({type: actionTypes.SET_LOADING_ASSISTENZA, value: true, tab: "aperte"});
        ServiceRequestsService.fetchAperte(integrationId, searchText, filterBy, state.sorting, page, rowsPerPage, aperteCancelToken.token)
            .then((res) => {
                dispatch({
                    type: actionTypes.FETCH_ASSISTENZA_DATA_SUCCESS,
                    tab: "aperte",
                    data: res.data.data,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    count: res.data.count
                });
                dispatch({type: actionTypes.SET_LOADING_ASSISTENZA, value: false, tab: "aperte"});
            }).catch((e) => {
            // console.error(e);
            if (!axios.isCancel(e)) {
                dispatch({type: actionTypes.SET_LOADING_ASSISTENZA, value: false, tab: "aperte"});
            }
        })
    }
}

export const fetchDataArchiviate = (page, rowsPerPage, filterBy, searchText) => {
    return dispatch => {
        let integrationId = store.getState().authReducer.selectedCompany.integrationId;
        let state = store.getState().richiestaAssistenzaReducer.archiviate;

        if (state.loading) {
            archiviateCancelToken.cancel();
            archiviateCancelToken = axios.CancelToken.source();
        }

        dispatch({type: actionTypes.SET_LOADING_ASSISTENZA, value: true, tab: "archiviate"});
        ServiceRequestsService.fetchArchiviate(integrationId, searchText, filterBy, state.sorting, page, rowsPerPage, archiviateCancelToken.token)
            .then((res) => {
                dispatch({
                    type: actionTypes.FETCH_ASSISTENZA_DATA_SUCCESS,
                    tab: "archiviate",
                    data: res.data.data,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    count: res.data.count
                });
                dispatch({type: actionTypes.SET_LOADING_ASSISTENZA, value: false, tab: "archiviate"});
            }).catch((e) => {
            // console.error(e);
            if (!axios.isCancel(e)) {
                dispatch({type: actionTypes.SET_LOADING_ASSISTENZA, value: false, tab: "archiviate"});
            }
        })
    }
}

export const setSortingRichiesta = (value, tab) => {
    return {
        type: actionTypes.SET_SORTING_RICHIESTA,
        value: value,
        tab: tab
    }
}

export const fetchRichiesteAssistenzaFilterSuggestions = (searchText, filterBy) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const state = store.getState().richiestaAssistenzaReducer;
    return dispatch => {
        if (state.richiesteAssistenzaSuggestion.loading) {
            suggestionCancelToken.cancel();
            suggestionCancelToken = axios.CancelToken.source();
        }

        const query = encodeData(`?integrationId=${integrationId}&${filterBy}=${searchText}`)
        dispatch(setLoadingSuggestionRichiesteAssistenza(true))
        ServiceRequestsService.fetchSuggestion(query, suggestionCancelToken.token)
            .then((res) => {
                dispatch({
                    type: actionTypes.SET_ASSISTENZA_FILTER_SUGGESTION_DATA,
                    suggestionList: res.data.data.map(d => filterBy === "msisdn" ? {text: d.msisdn} : {text: d.rowId})
                })
                dispatch(setLoadingSuggestionRichiesteAssistenza(false))
            }).catch((e) => {
            if (!axios.isCancel(e)) {
                dispatch(setLoadingSuggestionRichiesteAssistenza(false))
            }
        })
    }
}

export const setLoadingSuggestionRichiesteAssistenza = (val) => {
    return {type: actionTypes.SET_ASSISTENZA_SUGGESTION_LOADING, value: val}
}
